export default "__VITE_ASSET__q_9bgrVp__"